/**
 * Konfiguračný súbor aplikácie
 * Obsahuje globálne konštanty a nastavenia
 */

// API URL - hybridné riešenie pre development aj production
export const API_URL = process.env.VUE_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://intranet-backend.optikamania.sk/api' 
    : 'http://localhost:5001/api');

// Adresa backendu bez /api - pre súbory zo /uploads (obrázky, prílohy).
// Nepoužívať natvrdo produkčnú URL, inak sa mimo produkcie prílohy nezobrazia.
export const BACKEND_URL = API_URL.replace(/\/api\/?$/, '');

// Úplná URL k nahratému súboru: uploadUrl('podnety/x.png') alebo uploadUrl('/uploads/podnety/x.png')
export const uploadUrl = (cesta) => {
  if (!cesta) return '';
  if (/^(https?:|data:|blob:)/.test(cesta)) return cesta;
  const relativna = String(cesta).replace(/^\/+/, '');
  return `${BACKEND_URL}/${relativna.startsWith('uploads/') ? relativna : `uploads/${relativna}`}`;
};

// Nastavenia aplikácie
export const APP_CONFIG = {
  // Názov aplikácie
  appName: 'Mania Intranet',
  
  // Verzia aplikácie
  version: '1.0.0',
  
  // Nastavenia pre notifikácie
  notifications: {
    defaultTimeout: 5000,
    position: 'top-right'
  },
  
  // Nastavenia pre upload súborov
  uploads: {
    maxFileSize: 5 * 1024 * 1024, // 5MB
    allowedImageTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    allowedDocumentTypes: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
  }
};
